import 'bootstrap';

//Variables
let bodyElement = $('body');
let baseUrl = document.head.querySelector('meta[name="base-url"]').content;
const themeButton = document.querySelector('.theme-collapse-btn');
const themeSelectButton = document.querySelectorAll('.selectColor');
const themePanel = document.querySelector('.theme-panel');
const rootElement = document.querySelector(':root');
const themeForm = document.getElementById('themeForm');
const panelMenuSearch = document.querySelector('.panelMenuSearch');
const allPanelMenuItems = Array.from(document.querySelectorAll('.sidebar-nav .nav-item'));
const allPanelMenuTitles = Array.from(document.querySelectorAll('.sidebar-nav .nav-title'));
let scrollSidebarTimeout = null;

const customScrollWrapper = document.querySelectorAll('.custom-scroll-wrapper');

let panelMenuSearchTimeout = null;

panelMenuSearch?.addEventListener('input', (e) => {
    const searchedValue = e.target.value.trim().toLowerCase();

    if (panelMenuSearchTimeout) clearTimeout(panelMenuSearchTimeout);

    if (searchedValue === '') {
        allPanelMenuItems.forEach(item => {
            item.classList.remove('d-none');
        });

        allPanelMenuTitles.forEach(item => {
            item.classList.remove('d-none');
        });

        return;
    }

    panelMenuSearchTimeout = setTimeout(() => {
        allPanelMenuTitles.forEach(item => {
            item.classList.add('d-none');
        });

        allPanelMenuItems.forEach((item) => {
            item.classList.remove('d-none');

            if (!item.innerText.toLowerCase().includes(searchedValue)) {
                item.classList.add('d-none');
            }
        });
    }, 250);
});

//Functions
function blockScrollY() {
    bodyElement.css({
        'overflow-y': 'hidden',
        'touch-action': 'none',
        '-ms-touch-action': 'none',
        'position': 'fixed',
        'top': `-${window.scrollY}px`,
        'left': '0'
    });
}

function unblockScrollY() {
    const scrollY = bodyElement.css('top');

    bodyElement.css({
        'overflow-y': '',
        'touch-action': '',
        '-ms-touch-action': '',
        'position': '',
        'top': '',
        'left': ''
    });

    window.scrollTo({
        top: parseInt(scrollY || '0') * -1,
        behavior: 'instant'
    });
}

window.backToTop = function () {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

window.panelSidebarToggleMobile = function () {
    $('#sidebar').addClass('show');
    $('.sidebar-backdrop').addClass('show');
    blockScrollY();
};

$('.sidebar-backdrop').click(function () {
    $('#sidebar').removeClass('show');
    $('.sidebar-backdrop').removeClass('show');
    unblockScrollY();
});

const setTheme = (theme, url = false) => {
    let localStorageItem = theme;
    let localStorageItemUrl = false;

    if (theme.includes('url')) localStorageItemUrl = true;

    if (url && !localStorageItemUrl) {
        localStorageItem = `url('${theme}')`;
    } else if (!url && !localStorageItemUrl) {
        let themeFound = false;
        Object.keys(availableThemeObject).forEach((key) => {
            if (availableThemeObject[key] === theme) {
                themeFound = true;
            }
        });

        if (!themeFound) return;
    }

    localStorage.setItem('selectedTheme', localStorageItem);
    rootElement.style.setProperty('--_bgThemeColor', localStorageItem);

    Array.from(themeSelectButton).forEach((btn) => {
        btn?.classList.remove('active');

        Object.keys(availableThemeObject).forEach((key) => {
            if (availableThemeObject[key] === theme && btn?.classList.contains(key)) {
                btn?.classList.add('active');
            }
        });
    });

    if (localStorageItemUrl && themeForm) {
        themeForm.querySelector('input').value = theme.split('\'')[1];
    }
};

themeButton?.addEventListener('click', () => {
    const i = themeButton.querySelector('i');

    themePanel?.classList.toggle('active', !themePanel?.classList.contains('active'));

    i.className = themePanel?.classList.contains('active') ? 'fa fa-times' : 'fa fa-cog';
});

const availableThemeObject = {
    'theme-white': '#ffffff',
    'theme-darkwhite': '#dee2e6',
    'theme-dark': '#0f172a',
    'theme-gray': '#9ca3af',
    'theme-blue': '#22d3ee'
};

Array.from(themeSelectButton).forEach((btn) => {
    btn?.addEventListener('click', () => {
        const selectedTheme = Array.from(btn?.classList).pop();

        setTheme(availableThemeObject[selectedTheme] ?? availableThemeObject["theme-white"]);
    });
});

themeForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const sourceInputValue = Array.from(event.target).find((input) => input.name === 'source').value;

    setTheme(sourceInputValue, true);
});

function checkGoToTop() {
    if ($('html')[0].scrollTop > 100 || $(':root')[0].scrollTop > 100) {
        $(".btn-going-top").addClass('show');
    } else {
        $(".btn-going-top").removeClass('show');
    }
}

let eventTimeout;
let eventThrottler = function (function_name) {
    if (!eventTimeout) {
        eventTimeout = setTimeout(function () {
            eventTimeout = null;
            if (function_name === 'checkGoToTop') {
                checkGoToTop();
            }
        }, 1000);
    }
};

//Window scroll
$(window).scroll(function () {
    eventThrottler('checkGoToTop');
});

$(function () {
    const selectedTheme = localStorage.getItem('selectedTheme') ?? availableThemeObject["theme-white"];
    setTheme(selectedTheme);

    const sidebarScrollElement = document.querySelector('.simplebar-content-wrapper');
    sidebarScrollElement?.addEventListener('scroll', () => {
        if (scrollSidebarTimeout) clearTimeout(scrollSidebarTimeout);

        scrollSidebarTimeout = setTimeout(() => {
            localStorage.setItem('lastSidebarScrollTop', sidebarScrollElement.scrollTop);
        }, 250);
    });

    const lastSidebarScrollTop = localStorage.getItem('lastSidebarScrollTop') ?? '0';
    sidebarScrollElement?.scrollTo({
        top: lastSidebarScrollTop,
        behavior: 'instant'
    });
});

export function findPercentNumber(text){
    const percentIndex = text.indexOf('%');
    const regex = /[-]{0,1}[\d.,]*[\d]+/g;

    if (percentIndex !== -1) {
        const substringBeforePercent = text.substring(0, percentIndex);
        const matches = substringBeforePercent.match(regex);
        if (matches && matches.length > 0) {
            return parseFloat(matches[matches.length - 1].replace(',', '.'));
        }
    } else {
        const matches = text.match(regex);
        if (matches && matches.length > 0) {
            return parseFloat(matches[matches.length - 1].replace(',', '.'));
        }
    }

    return false;
}

customScrollWrapper.forEach(wrapper => {
    const container = wrapper.querySelector('.custom-scrollable-container');
    const leftButton = wrapper.querySelector('.custom-scroll-button-left');
    const rightButton = wrapper.querySelector('.custom-scroll-button-right');

    let scrollInterval;

    function startScrolling(direction) {
        stopScrolling();
        scrollInterval = setInterval(() => {
            container.scrollLeft += direction * 20;
        }, 20);
    }

    function stopScrolling() {
        clearInterval(scrollInterval);
    }

    // Obsługa dla kliknięć myszą
    [leftButton, rightButton].forEach(button => {
        button.addEventListener('mousedown', () => startScrolling(button === leftButton ? -1 : 1));
        button.addEventListener('mouseup', stopScrolling);
        button.addEventListener('mouseleave', stopScrolling);

        // Obsługa dla dotyku
        button.addEventListener('touchstart', () => startScrolling(button === leftButton ? -1 : 1));
        button.addEventListener('touchend', stopScrolling);
        button.addEventListener('touchcancel', stopScrolling);
    });
});